import { useSyncExternalStore } from 'react';
import { Station } from './routes/Station';
import { TextView } from './routes/TextView';
import { RecordView } from './routes/RecordView';
import { AgentDossier } from './routes/AgentDossier';

function subscribe(callback: () => void): () => void {
  window.addEventListener('popstate', callback);
  return () => window.removeEventListener('popstate', callback);
}

function getPath(): string {
  return window.location.pathname;
}

function useRoute(): string {
  return useSyncExternalStore(subscribe, getPath, () => '/');
}

function App() {
  const path = useRoute();

  if (path === '/text' || path.startsWith('/text/')) {
    return <TextView path={path} />;
  }
  if (path === '/record') {
    return <RecordView />;
  }
  const agentMatch = path.match(/^\/agents\/([a-z0-9-]+)$/i);
  if (agentMatch) {
    return <AgentDossier agentId={agentMatch[1]} />;
  }

  return <Station />;
}

export default App;
